module.exports = __webpack_public_path__ + "img/Flags_of_New_Caledonia.7d657612.svg";